<template>
    <div class="border-t border-white m-2 pt-2 text-sm leading-tight text-gray-800">
        <div class="w-full flex">
            <div class="w-1/3 text-right pr-2">
                <div>{{ $t('component.missionProfile.footer.customer_since') }}</div>
            </div>
            <div class="w-2/3">
                <div class="mb-1 ml-1"><LocalizedDate :date="missionDetail.customer_since"></LocalizedDate></div>
            </div>
        </div>

        <div class="w-full flex">
            <div class="w-1/3 text-right pr-2">
                <div>{{ $t('component.missionProfile.footer.customer_care_agent') }}</div>
            </div>
            <div class="w-2/3">
                <div class="mb-1 ml-1">{{ missionDetail.customer_care_agent }}</div>
            </div>
        </div>

        <div class="w-full flex">
            <div class="w-1/3 text-right pr-2">
                <div>{{ $t('component.missionProfile.footer.previous_missions') }}</div>
            </div>
            <div class="w-2/3 flex">
                <div class="mb-1 ml-1 mt-1">{{ missionDetail.previous_missions }}
                    <!--<GreenCheckSVG class="inline" v-for="n in missionDetail.previous_missions" :key="n"></GreenCheckSVG>-->
                </div>
                <div class="-ml-2">
                    <Verified v-if="missionDetail.previous_missions > 0"></Verified>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LocalizedDate from "@/components/shared/LocalizedDate";
    import Verified from "@/components/missions/labels/Verified";

    export default {
        name: "MissionProfileFooter",
        props: ['missionDetail'],
        components: {Verified, LocalizedDate }
    }
</script>

<style scoped>

</style>